module.exports = __webpack_public_path__ + "h5/img/renwus.4de5d782.png";